<!-- Banner di impersonificazione - sempre visibile se l'utente è impersonificato -->
<ape-impersonation-bar class="sticky top-0 z-50" (endImpersonation)="endImpersonation()" />

<!-- Header e Footer condizionali -->
<ape-header
  *ngIf="showHeaderFooter"
  (openNotificationSidenav)="notificationSidenavVisible = true"
  (openSupportSidenav)="supportSidenavVisible = true"
/>

<!-- Contenuto principale con layout condizionale -->
<div
  [ngClass]="{
    'flex w-full flex-col mx-auto flex-1 min-h-screen items-center justify-center': !showHeaderFooter,
    'flex w-full flex-col items-stretch mx-auto flex-1 max-w-[1348px] px-6 pt-[30px] pb-15': showHeaderFooter
  }">
  <router-outlet />
</div>

<!-- Footer condizionale -->
<ape-footer *ngIf="showFooter" [footerBackground]="footerBackground" />

<!-- Componente per mostrare alert/notifiche -->
<ape-alert />

<!-- Sidenav notifiche -->
<ape-notification-sidenav [(visible)]="notificationSidenavVisible" />

<!-- Sidenav supporto -->
<ape-support-sidenav [(visible)]="supportSidenavVisible" />
